
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people/technical/[slug]",
      function () {
        return require("private-next-pages/people/technical/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people/technical/[slug]"])
      });
    }
  